module.exports = __webpack_public_path__ + "img/Informationrelease.9c28c65d.png";